import { render, staticRenderFns } from "./F2.vue?vue&type=template&id=78eec4f4&scoped=true"
import script from "./F2.vue?vue&type=script&lang=js"
export * from "./F2.vue?vue&type=script&lang=js"
import style0 from "./F2.vue?vue&type=style&index=0&id=78eec4f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eec4f4",
  null
  
)

export default component.exports